import { SkeletonButton } from 'x-ui-design';
import { isMobile } from 'utils/is-mobile';

export const BetOnEventsSkeleton = () => {
  return (
    <SkeletonButton
      active
      style={{ width: '100%', height: isMobile() ? '222px' : '198px' }}
      applyElementStyle={false}
    />
  );
};
